// import React from "react";
// import "./StudentAchievement.scss";


// export default function StudentAchievement() {
//   return (
//  <>
//     <section className="achievement-section">
//       <div className="achievement-container">
//         <h2>🌟 Student Achievement</h2>
//         {/* <p className="achievement-text">
//           Our students consistently excel in academics, competitions, and
//           community service, making us proud with every milestone they achieve.
//         </p> */}
//       </div>
//     </section>

//     <section className="achievement-section">
//       {/* <h1>Student Achievements</h1> */}

//       <p>
//         It is with great pride and enthusiasm that I,{" "}
//         <span className="highlight">Dr. Devika S Ajila, Principal</span>, present the
//         College Report of <span className="highlight">Bengaluru Law College</span>,
//         highlighting our academic achievements, service initiatives, and
//         Institutional progress over the past years.
//       </p>

//       <p>
//         Since its establishment as <strong>R.K. Law College (2009)</strong> and its
//         transformation into <strong>Bengaluru Law College (2015)</strong> under the
//         Law Wings Educational Trust, our Institution has consistently upheld a
//         tradition of academic excellence and community service.
//       </p>

//       <h2>Rank Holders</h2>
//       <p>
//         Our students have demonstrated outstanding performance in Karnataka State
//         Law University (KSLU) examinations:
//       </p>
//       <ul className="list">
//         <li>🎓 <strong>Ravi C.S.</strong> – 3rd Rank (Kannada Medium, 2017 Batch)</li>
//         <li>🎓 <strong>Laxmi Devi</strong> – 6th Rank (2018 Batch)</li>
//         <li>🎓 <strong>Chaya Devi</strong> – 7th Rank (Kannada Medium, 2019 Batch)</li>
//         <li>🎓 <strong>Swathi N.</strong> – 2nd Rank (2020 Batch)</li>
//         <li>🎓 <strong>Divyashree</strong> – 5th Rank (English Medium, 2020 Batch)</li>
//       </ul>

//       <p>
//         In recognition of our commitment, Bengaluru Law College has been honored to
//         host the <strong>Karnataka State Law University (KSLU) Valuation Center</strong>{" "}
//         for the 8th consecutive time since 2022, and recently as a{" "}
//         <strong>Revaluation Center</strong>.
//       </p>

//       <h2>Distinguished Alumni in Judiciary</h2>
//       <ul className="list">
//         <li>⚖️ <strong>Prakrthi Y R (2015 Batch)</strong> – Civil Judge, JMFC</li>
//         <li>⚖️ <strong>Shri Devadas H (2015 Batch)</strong> – Additional Civil Judge, Honnalli</li>
//         <li>⚖️ <strong>N. Narasimha Murthy</strong> – Additional Civil Judge, JMFC</li>
//       </ul>

//       <p>
//         Their achievements inspire our current students, reinforcing our commitment
//         to nurturing future leaders in the legal field.
//       </p>

//       <h2>Beyond Academics</h2>
//       <p>
//         Our college is dedicated to fostering legal awareness, social responsibility,
//         and holistic development. We actively engage in{" "}
//         <strong>
//           community service initiatives, legal aid programs, and professional
//           development opportunities
//         </strong>
//         , ensuring our students are well-prepared for their careers.
//       </p>
//     </section>
//     </>
//   );
// }



import React from "react";
import "./StudentAchievement.scss";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";

export default function StudentAchievement() {
  return (
    <>
    <SectionTitle2 title="Students Achievements" />
      {/* <section className="achievement-section hero">
        <div className="achievement-container"> */}
          {/* <h2>🌟 Student Achievement</h2> */}
          {/* <p className="achievement-text">
            Our students consistently excel in academics, competitions, and
            community service, making us proud with every milestone they achieve.
          </p> */}
        {/* </div>
      </section> */}

      <section className="achievement-section">
        {/* <p>
          It is with great pride and enthusiasm that I,{" "}
          <span className="highlight">Dr. Devika S Ajila, Principal</span>,
          present the College Report of{" "}
          <span className="highlight">Bengaluru Law College</span>, highlighting
          our academic achievements, service initiatives, and Institutional
          progress over the past years.
        </p> */}
        {/* <p>It gives me great pride and pleasure to present the College Report of Bengaluru Law College, showcasing our academic accomplishments, community service initiatives, and Institutional growth over the past years.</p> */}

        {/* <p>
          Since its establishment as <strong>R.K. Law College (2005)</strong> and
          its transformation into{" "}
          <strong>Bengaluru Law College (2015)</strong> under the Law Wings
          Educational Trust, our Institution has consistently upheld a tradition
          of academic excellence and community service.
        </p> */}

        <h2>Distinguished Alumni in Judiciary</h2>
        <ul className="list">
          <li>
            ⚖️ <strong>Prakruthi Y R (2015 Batch)</strong> – Civil Judge, JMFC
          </li>
          <li>
            ⚖️ <strong>Shri. Devadas H (2015 Batch)</strong> – Additional Civil
            Judge, Honnalli
          </li>
          <li>
            ⚖️ <strong>N. Narasimha Murthy (2017 Batch)</strong> – Additional Civil Judge, JMFC
          </li>
        </ul>

        <p>
          Their achievements inspire our current students, reinforcing our
          commitment to nurturing future leaders in the legal field.
        </p>

        <h2>Rank Holders</h2>
        <p>
          Our students have demonstrated outstanding performance in Karnataka
          State Law University (KSLU) examinations:
        </p>
        <ul className="list">
          <li>
            🎓 <strong>Ravi C.S.</strong> – 3rd Rank (Kannada Medium, 2017 Batch)
          </li>
          <li>🎓 <strong>Laxmi Devi</strong> – 6th Rank (2018 Batch)</li>
          <li>
            🎓 <strong>Chaya Devi</strong> – 7th Rank (Kannada Medium, 2019
            Batch)
          </li>
          <li>🎓 <strong>Swathi N.</strong> – 2nd Rank (2020 Batch)</li>
          <li>
            🎓 <strong>Divyashree</strong> – 5th Rank and Gold medal in environmental law (English Medium, 2020
            Batch)
          </li>
        </ul>

        <p>
          In recognition of our commitment, Bengaluru Law College has been honored
          to host the{" "}
          <strong>Karnataka State Law University (KSLU) Valuation Center</strong>{" "}
          for the 8th consecutive time since 2022, and recently as a{" "}
          <strong>Revaluation Center</strong>.
        </p>

        

        <h2>Beyond Academics</h2>
        <p>
          Our college is dedicated to fostering legal awareness, social
          responsibility, and holistic development. We actively engage in{" "}
          <strong>
            community service initiatives, legal aid programs, and professional
            development opportunities
          </strong>
          , ensuring our students are well-prepared for their careers.
        </p>

        {/* 🌟 Alumni Relationship Section */}
        <h2>Alumni Relationship – Bengaluru Law College</h2>
        <p>
          The alumni of Bengaluru Law College form an integral part of the
          Institution’s legacy and growth. They not only carry the name of the
          college into society and the legal profession but also continue to
          remain closely connected with their alma mater.
        </p>

        <h2>Expression of Gratitude</h2>
        <p>
          As a token of respect and thankfulness, the alumni organize Guru Vandana
          to honor their teachers for their invaluable guidance. This tradition
          reflects the values of respect, gratitude, and lifelong bonding between
          teachers and students.
        </p>

        <h2>Alumni Contributions</h2>
        <p>
          The alumni have shown their love and commitment towards the college
          through several contributions, such as:
        </p>
        <ul className="list">
          <li>💧 Donation of water purifiers for students and staff welfare.</li>
          <li>
            🎤 Providing mic stands and other facilities to support academic and
            cultural events.
          </li>
          <li>🎁 Contributing mementos and assistance for college programs.</li>
          <li>
            🤝 Extending continuous support towards the betterment of the
            Institution.
          </li>
        </ul>

        <h2>Alumni Association</h2>
        <p>
          The Alumni Association of Bengaluru Law College acts as a bridge between
          the past and present students. It regularly engages with the college by:
        </p>
        <ul className="list">
          <li>📅 Organizing alumni meets and interactive sessions.</li>
          <li>
            🧭 Guiding students through mentorship, career counseling, and
            internship opportunities.
          </li>
          <li>
            🌱 Actively supporting the college in its developmental and outreach
            activities.
          </li>
        </ul>

        <h2>College’s Gratitude Towards Alumni</h2>
        <p>
          The college also expresses its gratitude to its alumni. On Graduation
          Day, alumni are felicitated and blessed by esteemed guests. They are
          warmly welcomed to all Institutional programs and are always considered
          as an integral part of every event at Bengaluru Law College.
        </p>

        <h2>A Lifelong Bond</h2>
        <p>
          This strong alumni relationship highlights mutual respect, continuous
          cooperation, and shared pride. The alumni remain an everlasting part of
          the college family, enriching its legacy and inspiring future
          generations.
        </p>
      </section>
    </>
  );
}
